/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";

import { colors } from "../../theme";

import tick from "../../assets/tick.svg";

export const Tick = ({ size }) => (
    <img
        src={tick}
        alt="Check mark"
        css={css`
            border-radius: 100%;
            height: ${size}px;
            width: ${size}px;
            padding: 6px;
            background-color: ${colors.success3};
            margin-right: 16px;
        `}
    />
);

const DoneItem = ({ text }) => (
    <li
        css={css`
            list-style: none;
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-bottom: 16px;
            > p {
                color: ${colors.neutral6};
            }
        `} // margin bottom needed for semantic UI
    >
        <Tick size={24} />
        <p>{text}</p>
    </li>
);

const CurrentItem = ({ text, number }) => (
    <li
        css={css`
            list-style: none;
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-bottom: 16px;
            > p {
                color: ${colors.neutral8};
            }
        `} // margin bottom needed for semantic UI
    >
        <div
            css={css`
                border-radius: 100%;
                height: 24px;
                width: 24px;
                padding: 6px;
                background-color: ${colors.secondary7};
                color: white;
                margin-right: 16px;
                text-align: center;
                line-height: 12px;
                font-weight: 800;
            `}
        >
            {number}
        </div>
        <p>{text}</p>
    </li>
);

const ToDoItem = ({ text, number }) => (
    <li
        css={css`
            list-style: none;
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-bottom: 16px;
            > p {
                color: ${colors.neutral6};
            }
        `} // margin bottom needed for semantic UI
    >
        <div
            css={css`
                border-radius: 100%;
                height: 24px;
                width: 24px;
                padding: 6px;
                background-color: ${colors.secondary3};
                color: ${colors.neutral8};
                margin-right: 16px;
                text-align: center;
                line-height: 12px;
                font-weight: 800;
            `}
        >
            {number}
        </div>
        <p>{text}</p>
    </li>
);

const CheckList = ({ doneItems, currentItem, toDoItems }) => {
    const doneItemsLength = doneItems ? doneItems.length : 0;
    return (
        <ul
            css={css`
                padding: 0;
                margin-bottom: 0;
            `}
        >
            {doneItems &&
                doneItems.map(item => <DoneItem key={item} text={item} />)}
            {currentItem && (
                <CurrentItem text={currentItem} number={doneItemsLength + 1} />
            )}
            {toDoItems &&
                toDoItems.map((item, index) => (
                    <ToDoItem
                        key={item}
                        text={item}
                        number={doneItemsLength + 2 + index}
                    />
                ))}
        </ul>
    );
};

export default CheckList;
